import { styled, Theme } from '@mui/material';
import { DatePicker, MobileDatePicker } from '@mui/x-date-pickers';

const commonStyles = (theme: Theme) => ({
  '& .MuiPaper-root': {
    borderRadius: theme.spacing(1),
    boxShadow: theme.shadows[8],
  },
  '& .MuiPickersDay-root': {
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
    },
    '&.Mui-selected': {
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
    },
  },
  '& .MuiPickersCalendarHeader-root': {
    backgroundColor: theme.palette.grey[50],
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
})

export const StyledDatePicker = styled(DatePicker)(({ theme }) => ({
  ...commonStyles(theme),
  '& .MuiInputBase-root': {
    display: 'none', // Hide the input since we're using icon-only trigger
  },
}));
export const StyledMobileDatePicker = styled(MobileDatePicker)(({ theme }) => ({
  ...commonStyles(theme),
}));